import module from 'contabilidad/polizas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('contabilidad.polizas.provisionIngresosPagos', {
    url: '/ingresos-pagos?{fecha_inicio:date}&{fecha_fin:date}&{ID_Cliente}&{CuentaBancaria}&{ids_clientes}&{campo}',
    params: {
      ids_clientes: {array: true},
    },
    data: {
      title: 'Póliza de Ingresos - Pagos',
    },
    resolve: {
      fechaInicio: ($stateParams) => $stateParams.fecha_inicio,
      fechaFin: ($stateParams) => $stateParams.fecha_fin,
      idCliente: ($stateParams) => $stateParams.ID_Cliente,
      cuentaBancaria: ($stateParams) => $stateParams.CuentaBancaria,
      idsClientes: ($stateParams) => $stateParams.ids_clientes,
      campo: ($stateParams) => $stateParams.campo,
    },
    views: {
      '@contabilidad': {
        template: '<contabilidad-polizas-provisioningresospagos fecha-inicio="fechaInicio" fecha-fin="fechaFin" id-cliente="idCliente" cuenta-bancaria="cuentaBancaria" ids-clientes="idsClientes" campo="campo"/>',
        controller: ($scope, fechaInicio, fechaFin, idCliente, cuentaBancaria, idsClientes, campo) => {
          $scope.fechaInicio = fechaInicio
          $scope.fechaFin = fechaFin
          $scope.idCliente = idCliente
          $scope.cuentaBancaria = cuentaBancaria
          $scope.idsClientes = idsClientes
          $scope.campo = campo
        },
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/routes/polizas/provisionIngresosPagos.js